import { Flame, Mountain, TrendingUp, Users } from 'lucide-react';

const planIcons = {
  connect: Users,
  ignite: Flame,
  ascend: TrendingUp,
  pinnacle: Mountain
};

export function featureValue(feature, planId) {
  const value = feature.values[planId];
  if (feature.type === 'included') return value ? 'Included' : 'Not included';
  if (feature.type === 'percentage') return `${value}%`;
  if (feature.type === 'sessions') return value === 0 ? 'Not included' : `${value} ${value === 1 ? 'session' : 'sessions'}`;
  return value;
}

export function monthlyPrice(price) {
  return `₹${price.toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
}

export default function SubscriptionCard({ plan, featureGroups, onSelect }) {
  const PlanIcon = planIcons[plan.id];
  const features = featureGroups.flatMap(group => group.features).filter(feature => {
    const value = feature.values[plan.id];
    return feature.type !== 'pending' && value !== false && value !== 0;
  });
  return (
    <article className={`subscription-card subscription-card--${plan.id}`} aria-labelledby={`plan-${plan.id}`}>
      <div className="subscription-card-heading">
        <span className="subscription-plan-icon" aria-hidden="true"><PlanIcon size={24} strokeWidth={1.8} /></span>
        <h3 id={`plan-${plan.id}`}>{plan.name}</h3>
        <p>{plan.description}</p>
      </div>
      <p className="subscription-price"><strong>{monthlyPrice(plan.price)}</strong><span>INR / month{plan.price === 0 ? ' · Free' : ''}</span></p>
      <button className="subscription-button" onClick={() => onSelect(plan.id)}>Enquire about {plan.name}<span aria-hidden="true"> ↗</span></button>
      <ul className="subscription-benefits">
        {features.map(feature => (
          <li key={feature.id}><span aria-hidden="true">✓</span><span>{feature.label}{feature.type !== 'included' && <strong> — {featureValue(feature, plan.id)}</strong>}</span></li>
        ))}
      </ul>
    </article>
  );
}
